import { IMenuItemDb } from "@dining/api-client";
import { IconButton, Stack } from "@fluentui/react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalType } from "../../common/commonConstants";
import { setModal, toggleAddItemPanel } from "../../reducers/diningReducer";
import { selectedItemSelector } from "../../selectors/diningSelector";

export const EditDeleteColumn = (props: { selectedGridDataGUID: string }) => {
  // Obtain selected item from redux store
  const selectedMenuItem: IMenuItemDb | undefined = useSelector(selectedItemSelector);
  const dispatch = useDispatch();

  const _handleDelete = () => {
    dispatch(setModal(ModalType.CONFIRM_MENU_ITEM_DELETE));
  };
  const _handleEdit = () => {
    dispatch(toggleAddItemPanel());
  };
  return (
    <Stack horizontal={true}>
      {selectedMenuItem?.id === props.selectedGridDataGUID && (
        <>
          <IconButton iconProps={{ iconName: "Edit" }} title="Edit" ariaLabel="Edit" onClick={_handleEdit} />
          <IconButton
            iconProps={{ iconName: "Delete" }}
            onClick={_handleDelete}
            styles={{
              root: { color: "red" },
              rootHovered: { color: "red" },
            }}
            title="Delete"
            ariaLabel="Delete"
          />
        </>
      )}
    </Stack>
  );
};
